import React from 'react';

const Notfound = () => {
    return (
        <div className='text-center container'>
            <h1>404</h1>
            <p>Page not found </p>
        </div>
    );
};

export default Notfound;